import React from "react";
import WarmupComercialCountCard from "./Components/WarmupComercialCountCard";

const DashboardComercial = () => {
    return (
        <div className="flex">
            <div className="flex gap-3 m-5">
                <WarmupComercialCountCard />
                <WarmupComercialCountCard />
                <WarmupComercialCountCard />
                <WarmupComercialCountCard />
            </div>
        </div>
    )
}

export default DashboardComercial